const { REACT_APP_INTAKE_SITE: INTAKE_SITE } = process.env;

const intake = [5];

export const hasIntake = (siteId) => {
  return Number(INTAKE_SITE) === siteId;
  // return intake.includes(siteId);
};
